import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import TextField from "@/common/elements/InputElements/TextField";
import {
  IntakeSectionHeader,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
  StyledTypographyText,
} from "@/common/styles";
import { forwardRef } from "react";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import { useSelector } from "react-redux";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { SCHEMA_NAME } from "@/util/common_variable";

const DeadlineInformation = forwardRef(({ deadlineStartDateTime, startingPoint = "" }, ref) => {
  const { bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );

  return (
    <FieldSecurityProvider
      entity={SCHEMA_NAME.CHARGES}
      startingPoint={startingPoint}
      bookingsFieldsEnabled={bookingsFieldsEnabled}
    >
      <>
        <IntakeSectionHeader ref={ref}>
          <span>Deadline Information</span>
        </IntakeSectionHeader>

        <FormContainer>
          <StyledGridRow gutter={16}>
            <StyledGridCol span={8}>
              <SecureFormItem
                fieldName="deadlineStartDateTime"
                formItemProps={{
                  name: "deadlineStartDateTime",
                  label: "Deadline Start Date/Time",
                  layout: "vertical",
                  rules: [
                    {
                      required: true,
                    },
                  ],
                }}
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  showTime={true}
                />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>

          <StyledGridRow gutter={16}>
            <StyledGridCol lg={6}>
              <SecureFormItem
                fieldName="deadlineDateTime1Local"
                formItemProps={{
                  name: "deadlineDateTime1Local",
                  // Default label; sites rename it via a Vocabulary row keyed
                  // on the DB field name (e.g. "36-Hour Court Appearance").
                  label: "Deadline 1 Date/Time",
                  vocabFieldName: "Deadline_DateTime1",
                  layout: "vertical",
                }}
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  showTime={true}
                />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol lg={13}>
              <SecureFormItem
                fieldName="deadlineSatisfied1"
                formItemProps={{
                  name: "deadlineSatisfied1",
                  layout: "horizontal",
                  labelPostion: "label-right",
                  label: "Deadline 1 Satisfied?",
                  valuePropName: "checked",
                }}
              >
                <Checkbox />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol lg={5}>
              <SecureFormItem
                fieldName="deadlineSatisfiedDateTime1"
                formItemProps={{
                  label: "Satisifed Date/Time",
                  name: "deadlineSatisfiedDateTime1",
                }}
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  showTime={true}
                />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>

          <StyledGridRow gutter={16}>
            <StyledGridCol lg={6}>
              <SecureFormItem
                fieldName="deadlineDateTime2Local"
                formItemProps={{
                  name: "deadlineDateTime2Local",
                  label: "Deadline 2 Date/Time",
                  vocabFieldName: "Deadline_DateTime2",
                  layout: "vertical",
                }}
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  showTime={true}
                />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol lg={13}>
              <SecureFormItem
                fieldName="deadlineSatisfied2"
                formItemProps={{
                  name: "deadlineSatisfied2",
                  layout: "horizontal",
                  labelPostion: "label-right",
                  label: "Deadline 2 Satisfied?",
                  valuePropName: "checked",
                }}
              >
                <Checkbox />
              </SecureFormItem>
            </StyledGridCol>

            <StyledGridCol lg={5}>
              <SecureFormItem
                fieldName="deadlineSatisfiedDateTime2"
                formItemProps={{
                  label: "Satisifed Date/Time",
                  name: "deadlineSatisfiedDateTime2",
                }}
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  showTime={true}
                />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>
        </FormContainer>
      </>
    </FieldSecurityProvider>
  );
});

export default DeadlineInformation;